import Axios from 'axios'
import React, { useEffect } from 'react'
import { FunctionComponent } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { toast } from 'react-toastify'

export const ArchiveMaterial: FunctionComponent = () => {
  const { materialId } = useParams<{ materialId: string }>()
  const history = useHistory()

  useEffect(() => {
    const deleteMaterial = async () => {
      await Axios.delete(
        `${process.env.REACT_APP_API_URL}/api/v1/materials/${materialId}`
      )

      toast.success('Материал архивирован.')

      history.push('/dashboard/materials')
    }

    deleteMaterial()
  }, [materialId, history])

  return (
    <div className="row">
      <div className="col">Архивирование материала.</div>
    </div>
  )
}
